import { defineStore } from 'pinia';
import { useLegs } from '@/lib/legs';

export const useLegsStore = defineStore('Leg', () => {
    const { legs, fetchLegs, initialize, completeLeg } = useLegs();

    // Initialize the Leg logic
    initialize();

    return {
        legs,
        fetchLegs,
        completeLeg,
    };
});